var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconListLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0125 0C4.48276 0 0 4.48276 0 10.0125V22.3878C0 23.1091 0.584708 23.6938 1.30598 23.6938C2.02726 23.6938 2.61197 23.1091 2.61197 22.3878V10.0125C2.61197 5.92531 5.92531 2.61197 10.0125 2.61197H22.2241C22.9454 2.61197 23.5301 2.02726 23.5301 1.30598C23.5301 0.584708 22.9454 0 22.2241 0H10.0125Z",
    fill: "#959595"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3853 6.16991C20.7418 5.53917 14.9551 5.53917 9.31162 6.16991C7.70391 6.3496 6.41197 7.61483 6.22247 9.235C5.55314 14.9578 5.55314 20.7391 6.22247 26.4619C6.41197 28.082 7.70391 29.3473 9.31162 29.5269C14.9551 30.1577 20.7418 30.1577 26.3853 29.5269C27.993 29.3473 29.2849 28.082 29.4744 26.4619C30.1438 20.7391 30.1438 14.9578 29.4744 9.235C29.2849 7.61483 27.993 6.3496 26.3853 6.16991ZM9.60174 8.76572C15.0524 8.15652 20.6445 8.15652 26.0952 8.76572C26.5085 8.81191 26.8334 9.13877 26.8802 9.53842C27.5259 15.0596 27.5259 20.6372 26.8802 26.1584C26.8334 26.5581 26.5085 26.8849 26.0952 26.9311C20.6445 27.5403 15.0524 27.5403 9.60174 26.9311C9.18844 26.8849 8.8635 26.5581 8.81676 26.1584C8.171 20.6372 8.171 15.0596 8.81676 9.53842C8.8635 9.13877 9.18844 8.81191 9.60174 8.76572Z",
    fill: "#959595"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconListLine);
export default __webpack_public_path__ + "static/media/icon_list_line.93cff805f398e702f1ebad3c6be6a93d.svg";
export { ForwardRef as ReactComponent };